const lang = {
  title_page: process.env.MIX_APP_NAME,
  form: 'ログインフォーム',
  email: 'メールアドレス',
  password: 'パスワード',
  error_message: 'メールアドレスかパスワードが正しくありません。',
  forget_password: 'パスワードを忘れた場合',
  btn_submit: 'ログイン',
  page_sub_title: 'デジタルツイン プロトタイプ',
}

export default lang
